<template>
    <div>
        <div @click="hide()" class="bg-effect popup-bg"></div>
        <div class="base-popup">
            <slot></slot>
        </div>
    </div>
</template>

<script>

    export default {
        name: "base-popup",
        data() {
            return {
            }
        },
        methods: {
            hide() {
                this.$emit("hide", false)
            }
        }
    }
</script>

<style scoped>
    .base-popup {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        background-color: var(--white-color);
        padding: 18px 24px;
        box-shadow: 0px 1px 20px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        z-index: 100;
    }
    .popup-bg{
        z-index: 99;
    }
</style>
